// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app[data-v-9aa24c64] {\r\n  width: 100%;\r\n  height: 100%;\n}\n.filters[data-v-9aa24c64] {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\n}\n.filters b-form-group[data-v-9aa24c64] {\r\n  flex: 1;\n}\n[dir=ltr] .filters b-form-group[data-v-9aa24c64] {\r\n  margin-right: 10px;\n}\n[dir=rtl] .filters b-form-group[data-v-9aa24c64] {\r\n  margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
